import React from 'react';
import { MainPageLayout } from '../layout/MainPageLayout';
import { DeviceChartDiv } from '../component/device-chart/DeviceChartDiv';

export const DeviceChartPage = () => (
  <MainPageLayout elementCentr={<DeviceChartDiv />} />
);
